module.exports = __webpack_public_path__ + "static/data-trends-blue-b4835bd3ea6693260fa0619c930cc5d4.svg";